import { cn } from "@/lib/utils";

export function Container({
  children,
  isDesktop,
}: {
  children: React.ReactNode;
  isDesktop?: boolean;
}) {
  return (
    <section
      className={cn(
        "h-full max-w-screen-xl p-8 pb-14 xl:mx-auto xl:px-4 2xl:px-0",
        isDesktop && "hidden lg:block"
      )}>
      {children}
    </section>
  );
}
